export default "__VITE_ASSET__BUGOIbrh__"